import {STATE_IDLE, STATUS_ERROR, STATUS_LOADING, STATUS_SUCCESS} from "../const";
import {AuthMutation} from "./types";

export default {
    [AuthMutation.AUTH_REQUEST](state) {
        state.status = STATUS_LOADING;
    },
    [AuthMutation.AUTH_SUCCESS](state, {token, user}) {
        state.status = STATUS_SUCCESS;
        state.token = token;
        state.user = user;
    },
    [AuthMutation.AUTH_ERROR](state, error) {
        state.status = STATUS_ERROR;
        state.lastError = error;
        state.token = null;
        state.user = {};
    },
    [AuthMutation.AUTH_LOGOUT](state) {
        state.user = {};
        state.token = null;
        state.status = STATE_IDLE;
    },
    [AuthMutation.UPDATE_SUCCESS](state, user) {
        state.status = STATE_IDLE;
        state.user = user;
    },
    [AuthMutation.UPDATE_ERROR](state, error) {
        state.status = STATUS_ERROR;
        state.lastError = error;
    },
};